/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CareyApproval
 */
export interface CareyApproval {
    /**
     * 
     * @type {string}
     * @memberof CareyApproval
     */
    request_id: string;
    /**
     * 
     * @type {string}
     * @memberof CareyApproval
     */
    chat_id?: string;
    /**
     * 'pending' | 'approved' | 'denied' | 'executed' | 'expired'
     * @type {string}
     * @memberof CareyApproval
     */
    status: string;
    /**
     * 'book' | 'reschedule' | 'cancel'
     * @type {string}
     * @memberof CareyApproval
     */
    action?: string;
    /**
     * Human-readable description of the action awaiting approval
     * @type {string}
     * @memberof CareyApproval
     */
    summary?: string;
}

/**
 * Check if a given object implements the CareyApproval interface.
 */
export function instanceOfCareyApproval(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "request_id" in value;
    isInstance = isInstance && "status" in value;

    return isInstance;
}

export function CareyApprovalFromJSON(json: any): CareyApproval {
    return CareyApprovalFromJSONTyped(json, false);
}

export function CareyApprovalFromJSONTyped(json: any, ignoreDiscriminator: boolean): CareyApproval {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'request_id': json['request_id'],
        'chat_id': !exists(json, 'chat_id') ? undefined : json['chat_id'],
        'status': json['status'],
        'action': !exists(json, 'action') ? undefined : json['action'],
        'summary': !exists(json, 'summary') ? undefined : json['summary'],
    };
}

export function CareyApprovalToJSON(value?: CareyApproval | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'request_id': value.request_id,
        'chat_id': value.chat_id,
        'status': value.status,
        'action': value.action,
        'summary': value.summary,
    };
}

